<script>
    import FrameworkReference from '../../Models/frameworkReferenceModel';
    import Loader from '../Loader.svelte';
    import SortableTable from '../SortableTable.svelte';
    import { addFormModal } from '../../Forms/ModalFormManager.svelte';
    import { notifier } from "@beyonk/svelte-notifications";
    import {confirm} from '../Confirmation.svelte';

    import {handleError} from '../../Utilities/handlePromise'

    let sortFields = [
        {
            field: "name",
            label: "Framework Name"
        }
    ]

    let formFields = [
        {
            name: "name",
            label: "Framework Name",
            required: true
        }
    ]

    let frameworks = FrameworkReference.getList();

    function addFramework() {
        addFormModal({
            fields: formFields,
            title: "Add Framework"
        }).then(formData => {
            FrameworkReference.createItem(formData).then(() => {
                notifier.success("Framework Created")
            })
        }, handleError)
    }

    function deleteFramework(framework) {
        confirm(`Are you sure you want to delete "${framework.name}?`).then(() => {
            FrameworkReference.delete(framework._id).then(() => {
                notifier.success("Framework Deleted");
            }, handleError)
        }, handleError)
    }
</script>

<Loader loading={!frameworks}>
    <div class="container is-fluid">
        <h1 class="title is-1">Frameworks</h1>
        <SortableTable {sortFields} tableData={$frameworks} showHideFields={false} actionsWidth="250">
            <div slot="filterActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addFramework}>Add Framework</button>
                </div>
            </div>
            <div slot="footerActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addFramework}>Add Framework</button>
                </div>
            </div>
            <div slot="rowActions" class="buttons is-right" let:row={framework}>
                <a class="button is-info" href="#/frameworkReference/fields/{framework._id}">Manage</a>
                <button class="button is-danger" on:click={() => deleteFramework(framework)}>Delete</button>
                <a class="button is-link" href="#/frameworkReference/{framework._id}">Open</a>
            </div>
        </SortableTable>
    </div>
</Loader>
